/**
 * INP: izvršava callback tek nakon što browser iscrta sljedeći frame,
 * da teški UI (eg. modal animacija) ne ulazi u INP.
 */
// Fallback timeout: ako browser ne crta frameove (npr. emulirani WebKit u E2E testovima, prozor u pozadini),
// rAF ne okida pa bi akcija izostala.
const FALLBACK_DELAY_MS = 100;

export default function runAfterNextPaint(callback) {
    let isDone = false;
    const run = () => {
        if (isDone) return;
        isDone = true;
        callback();
    };
    requestAnimationFrame(() => {
        setTimeout(run, 0);
    });
    setTimeout(run, FALLBACK_DELAY_MS);
}
